import React from "react";
import PropTypes from "prop-types";

import AbstractDropdown from "components/library/AbstractDropdown";

export default function Dropdown(props) {
  return <AbstractDropdown isAsync={false} {...props} />;
}

// This component can take all the same props as react-select but these are required for render.
Dropdown.propTypes = {
  options: PropTypes.arrayOf(PropTypes.object).isRequired,
};
